import { useTranslation } from "next-i18next";
import React from "react";
import { currency } from "utils";
import classes from "./CartDrawerMessage.module.scss";

interface ProgressBarProps {
  progress: number;
  amountToReachOrderMinimum: number;
  orderMinimumAmount: number;
}

const ProgressBar = ({
  progress,
  amountToReachOrderMinimum,
  orderMinimumAmount,
}: ProgressBarProps) => {
  const { t } = useTranslation("common");

  return (
    <div className={classes["cart-flyout-progress-bar"]}>
      <div
        style={{
          height: "35px",
          width: `${progress}%`,
          backgroundColor: "#d14124",
          borderRadius: "5px",
          textAlign: "center",
          position: "absolute",
        }}
      ></div>
      <p className={classes["cart-flyout-delivery-amount"]}>
        {t("checkout.minimum_unmet.add_text")}
        <span>{currency.format(amountToReachOrderMinimum)}</span>
        <span>{t("checkout.minimum_unmet.minimum_text")}</span>
        <span>${`${orderMinimumAmount}`}</span>
      </p>
    </div>
  );
};
export default ProgressBar;
